import { throttle } from "@/utils/fn";
import React, { useEffect, useRef } from "react";
import initPreview from "./initPreview.js";
import { ChatWindow } from "@/pages/Messaging/ChatWindow/types.js";
import PreviewDeviceFrame from "@/pages/Messaging/ChatWindow/Preview/PreviewDeviceFrame";

interface Props {
  type: string;
  workingChatWindow: ChatWindow;
  aiConfigId?: string;
}

export default function Preview(props: Props) {
  const el = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (el.current) {
      initPreview(el.current);
    }

    return () => {
      (window as any).MessengerPreview?.call("destroy");
      (window as any).MessengerPreview = undefined;
      (window as any).__messenger_preview = undefined;
      document.getElementById("messenger-preview-script")?.remove();
    };
  }, []);

  const sendUpdate = useRef(
    throttle((chatWindow: ChatWindow) => {
      const mp = (window as any).MessengerPreview;
      if (!mp || !chatWindow) return;
      mp.call("updateChatWindow", chatWindow);
    }, 25)
  );

  useEffect(() => {
    sendUpdate.current(props.workingChatWindow);
  }, [props.workingChatWindow]);

  useEffect(() => {
    const mp = (window as any).MessengerPreview;

    if (mp && props.type) {
      mp.call("updatePreview", props.type);
    }
  }, [props.type]);

  useEffect(() => {
    const mp = (window as any).MessengerPreview;

    if (mp && props.aiConfigId) {
      mp.call("updateAiConfigId", props.aiConfigId);
    }
  }, [props.aiConfigId]);

  const sc = props.workingChatWindow?.styleConfig || {};
  const launcherPosition =
    (sc as any).launcherPosition === "Left" ? "Left" : "Right";
  const actualWidth = (sc as any).windowWidth || undefined;
  const actualHeight = (sc as any).windowHeight || undefined;
  // launcherOffsetX/Y take precedence over the legacy sideSpacing/bottomSpacing values.
  const sideSpacing =
    typeof (sc as any).launcherOffsetX === "number"
      ? (sc as any).launcherOffsetX
      : (sc as any).sideSpacing;
  const bottomSpacing =
    typeof (sc as any).launcherOffsetY === "number"
      ? (sc as any).launcherOffsetY
      : (sc as any).bottomSpacing;
  const launcherVerticalPosition =
    (sc as any).launcherVerticalPosition === "top"
      ? "top"
      : (sc as any).launcherVerticalPosition === "middle"
      ? "middle"
      : "bottom";
  const windowBorderRadius =
    typeof (sc as any).windowBorderRadius === "number"
      ? (sc as any).windowBorderRadius
      : undefined;
  const mobileFullscreen =
    typeof (sc as any).mobileFullscreen === "boolean"
      ? (sc as any).mobileFullscreen
      : true;

  return (
    <PreviewDeviceFrame
      launcherPosition={launcherPosition}
      launcherVerticalPosition={launcherVerticalPosition}
      actualWidth={actualWidth}
      actualHeight={actualHeight && actualHeight > 0 ? actualHeight : undefined}
      sideSpacing={typeof sideSpacing === "number" ? sideSpacing : undefined}
      bottomSpacing={typeof bottomSpacing === "number" ? bottomSpacing : undefined}
      windowBorderRadius={windowBorderRadius}
      mobileFullscreen={mobileFullscreen}
    >
      <div ref={el}></div>
    </PreviewDeviceFrame>
  );
}
